import type { DetailMainProps } from "@widgets/detail";
import { DetailMain } from "@widgets/detail";

export const ArticleDetailMain = (props: DetailMainProps) => {
  return <DetailMain {...props} />;
};
